var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"button is-small pause",on:{"click":function($event){_vm.summaryModalOpen = true}}},[_vm._v("Zusammenfassung")]),(_vm.summaryModalOpen)?_c('SummaryModal',{attrs:{"has-ctas":false},on:{"close":function($event){_vm.summaryModalOpen = false}}},[_c('CurrentChainSummary')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }